import React from "react";
import BoardButton from "../BoardButton/BoardButton";

const BoardIconButton = ({
  icon,
  label,
  variant = "ghost-dark",
  className = "",
  ...rest
}) => (
  <BoardButton
    variant={variant}
    className={`pb-btn--icon ${className}`.trim()}
    aria-label={label}
    title={label}
    icon={icon}
    {...rest}
  />
);

export default BoardIconButton;
